<template>
  <li class="_sessions-event">
    <div :class="{'_sessions-event-overview': true, '_session-event-highlight': highlight, '_session-event-expand': expand}"
     @click="onExpand">
      <span class="_event-time">{{timeFormat(data.beginDate)}}</span>
      <span class="_event-icon-circle" :style="getStyle(data)"></span>
      <span class="_event-name">{{getEventName(data)}}</span>
      <span class="_session-plat" v-if="isSession"><i :class="'icon-' + data.platform.toLowerCase()"></i></span>
      <i class="_event-expand cicon-pagination-next"></i>
    </div>
    <div class="_sessions-event-detail" v-show="expand" :style="{height: expand && !queryReady ? '100px' : 'auto'}">
      <c-loading v-if="!queryReady"></c-loading>
      <div class="_sessions-event-prop" v-for="prop in attrInfos" :key="prop.attrId">
        <span class="_sessions-epro">{{prop.attrName}}: </span>{{prop.eventValue}}
      </div>
      <div class="_sessions-event-prop" v-for="prop in envInfos" :key="prop.name">
        <span class="_sessions-epro">{{prop.text}}: </span>{{prop.value}}
      </div>
    </div>
  </li> 
</template>
<script>
import {mapState} from 'vuex'
import {actions} from '../../store/constants'
import {util} from '../../utils'
export default {
  name: 'userInfoEvent',
  props: {
    data: null,
    isSession: {
      type: Boolean,
      default: false
    },
    sessionId: null,
    plat: null,
    uid: {
      type: Number,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expand: false,
      attrInfos: [],
      envInfos: [],
      queryReady: false // 是否已经查询过详情
    }
  },
  computed: {
    ...mapState({
      eventNameMap (state) {
        return state.bizSys.eventNameMap
      }
    }),
    queryParam () {
      const platMap = {
        ANDROID: 1,
        IOS: 2,
        JS: 3
      }
      const param = {
        appId: this.appId,
        platform: platMap[this.plat],
        sessionId: this.sessionId,
        uid: this.uid,
        beginDate: this.data.beginDate,
        cdpId: 0
      }
      if (!this.isSession) {
        param.eventId = this.data.eventId
        param.uuid = this.data.uuid
      }
      return param
    }
  },
  methods: {
    getEventName (data) {
      if (this.isSession) return '会话开始'
      const event = this.eventNameMap[data.eventName]
      return event && (event.alias_name || event.event_name)
    },
    getStyle (data) {
      return {
        'border-color': util.getColorByName(this.getEventName(data))
      }
    },
    timeFormat (time) {
      return `${this.$util.dateFormat(new Date(time))} ${this.$util.timeFormat(new Date(time))}`
    },
    onExpand () {
      this.expand = !this.expand
      if (this.expand && !this.queryReady) this.queryInfo()
    },
    queryInfo () {
      this.$store.dispatch(actions.userInfo.getEventInfo, this.queryParam)
      .then(res => {
        this.attrInfos = res.data[0].attr_infos
        this.envInfos = res.data[0].env_infos
        this.queryReady = true
      })
      .catch(err => {
        this.$message({
          type: 'error',
          message: '查询事件详情失败'
        })
        console.log('查询事件详情失败', err)
      })
    }
  }
}
</script>